module.exports = __webpack_public_path__ + "img/wszl.0782c3b3.png";